<template>
    <div class="background-login has-scroll-y">
        <div class="section">
            <div class="container">
                <div class="columns is-centered">
                    <div class="column is-two-fifths-desktop">
                        <login-form> </login-form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import LoginForm from '@/components/UserLoginForm';
export default {
    components: { LoginForm },
    mounted() {
        // console.log("loginpage")
    },
};
</script>
<style scoped>
.background-login {
    background-image: url('/img/login_background.png');
    height: 100%;
    width: 100%;
    position: absolute;
    background-repeat: no-repeat;
    background-size: cover;
}
</style>
